/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { DATE_QTR_FORMAT_ERROR } from '../../../SharedModules/Errors/constantMessageData';
import moment from 'moment';
const errorMessage = DATE_QTR_FORMAT_ERROR;

export const qtrMapping = {
  1: 'JAN',
  2: 'APR',
  3: 'JUL',
  4: 'OCT',
};

export const qtrMappingToDate = {
  1: 'MAR',
  2: 'JUN',
  3: 'SEP',
  4: 'DEC',
};

export const monthMapping = {
  '01': 'JAN',
  '02': 'FEB',
  '03': 'MAR',
  '04': 'APR',
  '05': 'MAY',
  '06': 'JUN',
  '07': 'JUL',
  '08': 'AUG',
  '09': 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};
export const monthMappingReverse = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAY: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OCT: '10',
  NOV: '11',
  DEC: '12',
};

//Follwoing function convert 01/01/1991 to 01-JAN-1991
export const quarterToDate = (input, type) => {
  let output = '';
  if (input.length === 4) {
    const splitInput = input.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');

      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1]}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1]}`;
    }
  }
  if (input.length === 6) {
    const splitInput = input.split('Q');
    if (type === 'toDate') {
      const qtrLastDay = moment()
        .quarter(moment(parseInt(splitInput[0])))
        .endOf('quarter')
        .format('MM/DD/YYYY');
      output = `${qtrLastDay.split('/')[1]}-${
        qtrMappingToDate[splitInput[0]]
      }-${splitInput[1].substring(2)}`;
    } else {
      output = `01-${qtrMapping[splitInput[0]]}-${splitInput[1].substring(2)}`;
    }
  }
  if (input.length === 10) {
    const splitInput = input.split('/');
    output = `${splitInput[1]}-${
      monthMapping[splitInput[0]]
    }-${splitInput[2].substring(2)}`;
  }
  if (input.length === 5) {
    const splitInput = input.split('/');
    output = `01-${monthMapping[splitInput[0]]}-${splitInput[1]}`;
  }

  if (input.length === 7) {
    const splitInput = input.split('/');
    output = `01-${monthMapping[splitInput[0]]}-${splitInput[1].substring(2)}`;
  }
  return output;
};

//Follwoing function convert 01/01/1991 from 01-JAN-1991
export const convertStringDate = (input) => {
  let output = '';
  const splitInput = input.split('-');
  const year =
    parseInt(splitInput[2]) > 90 ? `19${splitInput[2]}` : `20${splitInput[2]}`;
  output = `${monthMappingReverse[splitInput[1]]}/${splitInput[0]}/${year}`;
  return output;
};

// Validate date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits and or a valid quarter and year in the form ‘#Q##  or#Q####’ such as ‘1Q98 or 1Q1998’.';
export const validateDate = (date, key) => {
  const errors = [];
  const fourDigitYearReg = /^[1-4]Q[1-9][0-9]{3}$/;
  const twoDigitYearReg = /^[1-4]Q[0-9]{2}$/;
  const allowedLength = [6, 4, 10, 7, 5];
  if (allowedLength.indexOf(date.length) !== -1) {
    if (date.length === 6) {
      if (!fourDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      } else {
      }
    }
    if (date.length === 4) {
      if (!twoDigitYearReg.test(date)) {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }

    if (date.length === 10) {
      const dateValue = new Date(date);
      if (dateValue == 'Invalid Date') {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }

    if (date.length === 7) {
      let splittedValue = date.split('/');
      splittedValue = splittedValue[0] + '/01/' + splittedValue[1];
      if (new Date(splittedValue) == 'Invalid Date') {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
    if (date.length === 5) {
      let splittedValue = date.split('/');
      splittedValue = splittedValue[0] + '/01/20' + splittedValue[1];
      if (new Date(splittedValue) == 'Invalid Date') {
        errors.push({
          field: key,
          message: errorMessage,
        });
      }
    }
  } else {
    if (key === 'fromDate') {
      errors.push({
        field: key,
        message: errorMessage,
      });
    }
    if (key === 'toDate' && date.trim() !== '') {
      errors.push({
        field: key,
        message: errorMessage,
      });
    }
  }
  return errors;
};
